<div
  id="transaction-form"
  class="transaction-form"
>
  <mm-banners
    id="generic-service-error-banner"
    *ngIf="showGenericServerError"
    [bannerText]="[genericserverErrorText]"
    [type]="'error'"
  ></mm-banners>
  <!-- Setting tabIndex '-1' to allow programmatic focus since ag-grid assigns focus to the active cell when start transaction is clicked from table -->
  <span
    id="transaction-form-header"
    class='section-title'
    tabindex="-1"
  >{{transactionFormHeader}}</span><br>
  <mm-banners
    class="pal-info-banner"
    *ngIf="palAccountInContext"
    data-testid="pal-transaction-info-banner"
    [bannerText]="[palInfoBannerText]"
    [type]="'information'"
    [showCloseIcon]="true">
  </mm-banners>
  <mm-spinner
    [loading]="formSpinnerState$"
    [makeInert]="false"
  ></mm-spinner>
  <mm-spinner
    [loading]="editPageSpinnerState$"
    [makeInert]="false"
  ></mm-spinner>
  <mm-banners
    *ngIf="hasServiceError"
    [serviceError]="(transactionFormServiceError$ | async)!"
    [type]="'error'"
  ></mm-banners>
  <mm-banners
    id="multiple-validation-errors"
    data-testid="multiple-validation-error-banner"
    *ngIf="multipleVerifyErrors.length > 0 && !hasInternationalFedTaxError"
    [useBulletedListDisplay]="true"
    [titleText]="'Please call your Service Team or try again later to submit this transaction.'"
    [bannerText]="multipleVerifyErrors"
    [type]="'error'"
  ></mm-banners>
  <mm-view-move-money-page *ngIf="isBtMasterOnly"></mm-view-move-money-page>
  <!-- Yellow warning banner for no Move Money access or ineligible account -->
  <mm-banners
    *ngIf="showUnauthorizedAccess"
    [htmlStr]="[showAccessDeniedBanner]"
    [type]="'warning'"
    data-testid="move-money-access-banner"
  ></mm-banners>
  <mm-banners
    *ngIf="showPTRSDenied"
    [htmlStr]="[showPTRSDeniedBanner]"
    [type]="'warning'"
    data-testid="move-money-access-banner"
  ></mm-banners>
  <mm-banners
    *ngFor="let error of achErrorList; let i = index"
    [bannerText]="[error.messageText]"
    [type]="'error'"
    [attr.data-testid]="'achErrorList-' + (i + 1)"
  ></mm-banners>
  <div *ngIf="(hasMoveMoneyDataAccess || isEmployee) && isValidRegType && !isBtMasterOnly && !showPTRSDenied">
    <form
      *ngIf="!hasHeaderStateError"
      [formGroup]="transactionForm"
      id="form-container"
      data-testid="transactionForm"
    >
      <!-- TRANSACTION TYPE SELECTOR -->
      <mm-radio-control
        *ngIf="transactionTypeControl?.radios?.length"
        [parentForm]="transactionForm"
        [radioModel]="transactionTypeControl"
        class="medium-bottom-spacer"
      ></mm-radio-control>

      <div [ngSwitch]="transactionType">
        <!-- EXTRA PROMPTS AND TRANSACTION DETAILS -->
        <div *ngSwitchCase="'ach'">
          <div *ngIf="(standingAuthCallSucceededAch$ | async)!">
            <mm-ach-extra-prompts
              [parentForm]="transactionForm"
              [isInitiateAndRelease]="isInitRelease"
              [prefilledPrompts]="$any(prefilledForm?.extraPrompts)"
              [prefilledPromptsObs]="$any(prefilledPromptsObs).asObservable()!"
              (extraPromptsComplete)="onExtrasCompleted($event)"
            ></mm-ach-extra-prompts>
            <div *ngIf="(readyForTransactionDetails$ | async) && displayAchTransactionDetails">
              <mm-transaction-details-ach
                [parentForm]="transactionForm"
                [prefilledPrompts]="$any(prefilledForm?.transactionDetails)"
                [isAddAchOnRequestProfile]="isAddAchOnRequestProfile"
                [isEdit]="isEdit"
              ></mm-transaction-details-ach>
            </div>
          </div>
        </div>
        <div *ngSwitchCase="'internal-transfer'">
          <mm-it-extra-prompts
            [editFormDetails]="prefilledForm"
            [parentForm]="transactionForm"
            [displayPositionsWarning]="displayPositionsWarning"
            [maxLotsWarningMessage]="maxLotsWarningMessage"
            [maxLotsWarning]="maxLotsWarning"
            [prefilledPromptsObs]="$any(prefilledPromptsObs).asObservable()!"
            (extraPromptsComplete)="onExtrasCompleted($event)"
            (extraPromptsUpdatedInEdit)="onExtraPromptsUpdated()"
          ></mm-it-extra-prompts>
          <div *ngIf="(readyForTransactionDetails$ | async) || isEditSubmittedTransaction">
            <ng-container *ngIf="showMultipleToAccount(); else singleToAccount">
              <mm-multiple-transaction-details-it
                [editFormDetails]="prefilledForm"
                [parentForm]="transactionForm"
                [displayPositionsWarningPhase2]="displayPositionsWarningPhase2"
                [maxLotsWarningMessage]="maxLotsWarningMessage"
                [maxLotsWarning]="maxLotsWarning"
              ></mm-multiple-transaction-details-it>
            </ng-container>
            <ng-template #singleToAccount>
              <mm-transaction-details-it
                [editFormDetails]="prefilledForm"
                [parentForm]="transactionForm"
                [displayPositionsWarning]="displayPositionsWarning"
                [maxLotsWarningMessage]="maxLotsWarningMessage"
                [maxLotsWarning]="maxLotsWarning"
                [internalTransferTransaction]="transactionType"
              ></mm-transaction-details-it>
            </ng-template>
          </div>
        </div>
        <div *ngSwitchCase="'wire'">
          <mm-wire-extra-prompts
            [parentForm]="transactionForm"
            [palAccountInContext]="palAccountInContext"
            [prefilledPrompts]="$any(prefilledForm?.extraPrompts)"
            [prefilledPromptsObs]="$any(prefilledPromptsObs).asObservable()!"
            (extraPromptsComplete)="onExtrasCompleted($event)"
          ></mm-wire-extra-prompts>
          <div *ngIf="(readyForTransactionDetails$ | async)">
            <mm-transaction-details-wire-interim-iso
              [parentForm]="transactionForm"
              [palAccountInContext]="palAccountInContext"
              [prefilledPrompts]="$any(prefilledForm?.transactionDetails)"
            ></mm-transaction-details-wire-interim-iso>
          </div>
        </div>
        <div *ngSwitchCase="'check'">
          <mm-check-extra-prompts
            [editFormDetails]="prefilledForm"
            [parentForm]="transactionForm"
            [prefilledPrompts]="$any(prefilledForm?.extraPrompts)"
            [prefilledPromptsObs]="$any(prefilledPromptsObs).asObservable()!"
            (extraPromptsComplete)="onExtrasCompleted($event)"
          ></mm-check-extra-prompts>
          <div *ngIf="(readyForTransactionDetails$ | async) || isEditSubmittedTransaction">
            <mm-transaction-details-check
              [parentForm]="transactionForm"
              [editFormDetails]="prefilledForm"
              (overnightCheckFailure)="setShowOvernightWarningEvent($event)"
              [prefilledPrompts]="$any(prefilledForm?.transactionDetails)"
              [checkTransactionType]="transactionType" 
              [isEditRecurringSubmittedCheckTransaction]="isEditRecurringSubmittedCheckTransaction"
            ></mm-transaction-details-check>
          </div>
        </div>
      </div>
      <sdps-divider variation="secondary"></sdps-divider>
      <div id="button-container">
        <button
          id="transactionFormPage_cancelButton"
          (click)="onCancelClick()"
          type="button"
          class="sdps-button sdps-button--small sdps-button--secondary"
        >Cancel</button>
        <button
          *ngIf="showSaveTemplateButton"
          (click)="onSaveTemplateClick()"
          id="transactionFormPage_saveTemplateButton"
          data-testid="transactionFormPage_saveTemplateButton"
          type="button"
          class="sdps-button sdps-button--small sdps-button--secondary"
        >Save this as a template</button>
        <button
          [disabled]="showOvernightWarning"
          id="transactionFormPage_continueButton"
          data-testid="transactionFormPage_continueButton"
          (click)="onContinueClick()"
          type="submit"
          class="sdps-button sdps-button--primary sdps-button--small"
        >Continue</button>
      </div>
    </form>
  </div>
  <cashiering-ira-agreement-modal [showModal]="showCashieringIraAgreement$"></cashiering-ira-agreement-modal>
</div>
